/*
  Manifest Media — scroll reveal and count-up.

  Two IntersectionObservers, one script, loaded once from theme.liquid.

  The reveal styles are gated behind an .mm-ready class on <html> which
  this file adds immediately. Without that gate a JS failure, a blocked
  script or an old browser would leave every revealed section at
  opacity:0 — the whole page invisible. Gated, the worst case is that
  the animation simply never happens and everything renders normally.

  Both observers unobserve after firing. These are one-shot entrances,
  and leaving them attached would keep re-running the count on every
  scroll past.
*/
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Nothing below works without IntersectionObserver, and the reveal
  // would strand content hidden. Leave .mm-ready off and bail.
  if (!('IntersectionObserver' in window) || reduced) return;

  root.classList.add('mm-ready');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // ---- Scroll reveal -------------------------------------------------
    var revealIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('mm-in');
          revealIO.unobserve(e.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );
    // Anything already on screen at load is revealed IMMEDIATELY, with
    // no transition. The observer would get there too, but only after
    // this deferred script has parsed and DOMContentLoaded has fired,
    // and until then the element sits at opacity 0. On the enquiry page
    // that meant the form itself was invisible for the first moment,
    // which is worse than no animation at all. Only content below the
    // fold animates in, which is the only place the effect reads.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.mm-rev').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) {
        el.classList.add('mm-instant', 'mm-in');
        return;
      }
      revealIO.observe(el);
    });

    // ---- Count up ------------------------------------------------------
    // Locale is fixed to en-ZA so a visitor's own locale cannot turn
    // "30,000" into "30.000" and change what the number appears to say.
    function fmt(value, decimals) {
      return decimals > 0
        ? value.toFixed(decimals)
        : Math.round(value).toLocaleString('en-ZA');
    }

    var countIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          countIO.unobserve(el);

          var to = parseFloat(el.dataset.to);
          if (isNaN(to)) return;
          var dec = parseInt(el.dataset.dec || '0', 10);
          var pre = el.dataset.prefix || '';
          var suf = el.dataset.suffix || '';

          var duration = 1500;
          var start = performance.now();

          function tick(now) {
            var p = Math.min(1, (now - start) / duration);
            // Cubic ease-out: fast first, settling on the real figure.
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = pre + fmt(to * eased, dec) + suf;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.4 }
    );
    document.querySelectorAll('.mm-count').forEach(function (el) {
      countIO.observe(el);
    });
  });
})();
